module.exports = __webpack_public_path__ + "static/img/pc-05.810424b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/pc-05.jpg
// module id = 0g5n
// module chunks = 1